import React, { forwardRef } from 'react';
import { Checkbox as AKCheckbox } from '@atlaskit/checkbox';

import type { CheckboxProps } from './types';

export { CheckboxSkeleton } from './skeleton';
export default forwardRef<HTMLInputElement, CheckboxProps>((props: CheckboxProps, ref) => {
	const { defaultChecked = false, ...rest } = props;
	return <AKCheckbox defaultChecked={defaultChecked} ref={ref} {...rest} />;
});
